import { epicConstants } from '../constants'

const initialState = {
  accessToken: null,
  errorMessage: null,
  authenticated: false,
  epicId: null,
}

const epicReducer = (state = initialState, action) => {
  const { response, error } = action
  switch (action.type) {
    // Auth User
    case epicConstants.SAVE_AUTH_USER:
      return {
        ...state,
        authenticated: true,
        epicId: response.epicId,
        accessToken: response.code,
      }
    // Logout
    case epicConstants.REMOVE_AUTH_USER:
      return {
        ...state,
        authenticated: false,
        epicId: null,
        accessToken: null,
      }
    case epicConstants.EPIC_ACTIVATE_GAME_SUCCESS:
      return { ...state }

    // epic User's Ticket - localStorage
    case epicConstants.SAVE_USER_TICKET_SUCCESS:
      return { ...state, epicId: response.epicId, accessToken: response.code }
    case epicConstants.SAVE_USER_TICKET_FAILURE:
      return { ...state, epicId: null, accessToken: null }
    default:
      return state
  }
}

export default epicReducer
